import type { TagHierarchy, TagColor } from './tag.types'

/** Canonical hierarchy keys recognised by the two-prop API. */
const HIERARCHY_KEYS = new Set<TagHierarchy>(['subtle', 'solid'])

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

/**
 * Converts a two-prop variant+color pair into the combined theme key used
 * internally (e.g. `resolveTagVariantKey('subtle','blue') => 'subtleBlue'`).
 * When `color` is omitted, `'blue'` is used as the default.
 *
 * If `variant` is already a fully-qualified legacy key (e.g. `'subtleBlue'` or
 * `'subtleBlue'`) it is returned unchanged so the new API is backward-compatible.
 *
 * Returns `'subtleBlue'` (the default variant) when `variant` is absent.
 */
export const resolveTagVariantKey = (variant: string | undefined, color: TagColor | string | undefined): string => {
  if (!variant) return `subtle${capitalize(color ?? 'blue')}`

  // Already a combined / legacy key — pass through unchanged.
  if (!HIERARCHY_KEYS.has(variant as TagHierarchy)) return variant

  // New two-prop API: combine hierarchy + color (defaults to 'blue').
  return `${variant}${capitalize(color ?? 'blue')}`
}
